import React from 'react';
import { Heart, Star, Sparkles, Crown } from 'lucide-react';
import { getPlanMeta } from '@/lib/plans';

const ICONS = { Heart, Star, Sparkles, Crown };

export const PlanBadge = ({ planType, className = '' }) => {
  const meta = getPlanMeta(planType);
  const Icon = ICONS[meta.icon] || Heart;
  return (
    <div
      data-testid="plan-badge"
      className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-semibold ${meta.pillClass} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      <span>{meta.label}</span>
    </div>
  );
};

export default PlanBadge;
